import Statuses from "./Statuses";
import store from "../../../redux/store";
import { t } from "i18next";

export const showStatus = (status, snackArgs) => {
  let s = Statuses[status];

  if (status === "success") {
    s = {
      message: t("message.success", snackArgs),
      severity: "success"
    };
  } else if (!s) {
    s = {
      message: t("message.error", snackArgs),
      severity: "error"
    };
  }

  store.dispatch({
    type: "SHOW_SNACKBAR",
    payload: { message: s.message, severity: s.severity, open: true }
  });
}